import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class FacetController extends React.Component {
    constructor(props) {
        super(props);
        this.store = ComponentRegistry.getStore("ProductBrowserFacetStore");
        this.productsStore = ComponentRegistry.getStore("ProductBrowserStore");
        this.state = {
            filters: this.store.values,
            values: this.productsStore.filters,
        };

        this.store.listen(this.onFacetsChange.bind(this));
        this.productsStore.listen(this.onFiltersChange.bind(this));
    }

    onFacetsChange(state) {
        this.setState({ filters: state });
    }

    onFiltersChange(items, paging, sorting, filters) {
        this.setState({ values: filters });
    }

    onChange(property, value) {
        this.productsStore.filter(property, value);
    }

    render() {
        const FacetsView = ComponentRegistry.get(this.props.view);
        const FacetView = ComponentRegistry.get(this.props.facetView);

        const facets = Object.keys(this.state.filters).map(
            (facet) => {
                const facetType = this.props.facetTypes[this.state.filters[facet].type];
                if (typeof facetType !== "undefined") {
                    const Facet = ComponentRegistry.get(facetType);
                    return (
                        <FacetView key={facet} {...this.state.filters[facet]}>
                            <Facet
                                {...this.state.filters[facet]}
                                onChange={value => this.onChange(facet, value)}
                                value={this.state.values[facet]}
                                labels={this.props.labels}
                            />
                        </FacetView>
                    );
                }
                return null;
            },
        );

        return (
            <FacetsView>{facets}</FacetsView>
        );
    }
}

FacetController.propTypes = {
    view: PropTypes.string.isRequired,
    facetView: PropTypes.string.isRequired,
    facetTypes: PropTypes.objectOf(PropTypes.string),
};


FacetController.defaultProps = {
    view: "ProductBrowserViewsFacetsView",
    facetView: "ProductBrowserViewsFacetView",
};


// WEBPACK FOOTER //
// ./src-js/Fratello/ProductBrowser/Controllers/FacetController.jsx